import React, { useState } from 'react';
import OtpPage from '../../../components/OtpPage/OtpPage';
import {
  login,
  confirmOtp,
  getUserProfile
} from '../../../common/constants/api';
import { setToken } from '../../../common/utils/auth-utils';
const HeroImage = '/images/updated.png';
const Logo = '/images/logo-48.png';
const Logo2x = '/images/logo-192.png';
const Money = '/images/icons/Money.svg';
const Approval = '/images/icons/Approval.svg';
const Trust = '/images/icons/Trust.svg';
const Hand = '/images/icons/Hand.svg';
const Experian = '/images/icons/Experian.svg';
const Call = '/images/icons/call.svg';
const Mail = '/images/icons/mail.svg';
import { navigate } from 'gatsby';
import './Login.css';
import FormikWizard from 'formik-wizard';
import steps from './steps';
import SignIn from '../../../components/SignIn/SignIn';

const footerItems = [
  {
    logo: {
      src: Money,
      alt: 'Money'
    },
    caption: '1 Application - > 50 + Lenders'
  },
  {
    logo: {
      src: Approval,
      alt: 'Approval'
    },
    caption: 'Instant Approval'
  },
  {
    logo: {
      src: Trust,
      alt: 'Trust'
    },
    caption: 'Trusted by 1,00,000+ Customers'
  },
  {
    logo: {
      src: Hand,
      alt: 'Hand'
    },
    caption: '1,200 + Cr disbursed'
  },
  {
    logo: {
      src: Experian,
      alt: 'Experian',
      className: 'h-8'
    }
  }
];
function FormWrapper({
  children,
  isLastStep,
  status,
  values,
  setStatus,
  goToPreviousStep,
  canGoBack,
  wizard,
  err,
  actionLabel
}) {
  const [btnId, setbtnId] = useState(2);

  return (
    <div className=" relative flex flex-wrap flex-col  items-end ">
      <div className="flex-1 w-full flex flex-wrap flex-col md:flex-row h-auto relative overflow-y-hidden">
        <div className="flex flex-col w-full mt-5 lg:w-4/4 px-2 justify-center font-normal lg:items-start overflow-y-auto">
          {wizard.step.id == 'otp' ? (
            <OtpPage
              wizard={wizard}
              values={values}
              previousStep={goToPreviousStep}
            />
          ) : (
            <SignIn loginFrom={'RM'} />
          )}
        </div>
      </div>
    </div>
  );
}
const Login = () => {
  const handleSubmit = React.useCallback(values => {
    return regisrerOtp(values.otp, values.signup);
  }, []);
  let regisrerOtp = async (sectionValues, formValues) => {
    const values = {};
    if (formValues.mobile) {
      values.phone = formValues.mobile;
      values.email = formValues.email;
      values.mobileOtp = sectionValues.mobileOtp;
      values.emailOtp = sectionValues.emailOtp;
      try {
        await confirmOtp(values, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        try {
          let res = await login({
            username: formValues.mobile,
            userType: 0,
            password: formValues.password
          });
          let [id, token, username] = [res.id, res.token, res.username];
          await setToken({ id, token, username });

          let resp = await getUserProfile();
          localStorage.setItem('userData', JSON.stringify(resp));

          navigate('/app/dashboard');
        } catch (err) {
          return err.response?.data;
        }
      } catch (err) {
        return err.response?.data;
      }
    }
  };
  return (
    <FormikWizard steps={steps} onSubmit={handleSubmit} render={FormWrapper} />
  );
};
export default Login;
